import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const DownPayAccountActiveData = createSlice({
  name: "DownPayAccountActiveData",
  initialState: {
    data: {},
  },
  reducers: {
    addDownPayData: (state, action?: any) => {
      state.data = action.payload;
    },
    clearDownPayData: (state) => {
      state.data = {};
    },
  },
});
export default DownPayAccountActiveData.reducer;
export const { addDownPayData, clearDownPayData } =
  DownPayAccountActiveData.actions;
